// eq 等于
// neq 不等于
// gt 大于
// egt 大于等于
// lt 小于
// elt 小于等于
// like 含有
// between 之间
// 数据类对比方法
const contrastNum = (obj, num) => {
  // 判断是否有设置对比参数
  const keys = ["eq", "neq", "gt", "egt", "lt", "elt", "like", "between"];
  let objKeys = Object.keys(obj);
  let hasContrastKey = false;
  for (let key of keys) {
    if (objKeys.includes(key)) {
      hasContrastKey = true;
      break;
    }
  }
  if (!hasContrastKey) return hasContrastKey;

  if (typeof num == "string") num = parseFloat(num);
  let status = true;
  // console.log(obj, num);
  if ((Boolean(obj.eq) || obj.eq === 0) && num !== obj.eq) {
    // console.log('eq');
    status = false;
  }
  if ((Boolean(obj.neq) || obj.neq === 0) && num === obj.neq) {
    // console.log('neq');
    status = false;
  }
  if ((Boolean(obj.gt) || obj.gt === 0) && !(num > obj.gt)) {
    // console.log('gt');
    status = false;
  }
  if ((Boolean(obj.egt) || obj.egt === 0) && !(num >= obj.egt)) {
    // console.log('egt');
    status = false;
  }
  if ((Boolean(obj.lt) || obj.lt === 0) && !(num < obj.lt)) {
    // console.log('lt');
    status = false;
  }
  if ((Boolean(obj.elt) || obj.elt === 0) && !(num <= obj.elt)) {
    // console.log('elt');
    status = false;
  }
  if (
    Boolean(obj.between) &&
    Array.isArray(obj.between) &&
    obj.between.length === 2 &&
    !(num >= obj.between[0] && num <= obj.between[1])
  ) {
    // console.log('between');
    status = false;
  }
  if (Boolean(obj.like) && Array.isArray(obj.like) && !obj.like.includes(num)) {
    // console.log('like');
    status = false;
  }
  return status;
};

//乘法
Number.prototype.mul = function(arg) {
  var m = 0,
    s1 = this.toString(),
    s2 = arg.toString();
  try {
    m += s1.split(".")[1].length;
  } catch (e) {}
  try {
    m += s2.split(".")[1].length;
  } catch (e) {}
  return (
    (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) /
    Math.pow(10, m)
  );
};
//加法
Number.prototype.add = function(arg) {
  var r1, r2, m;
  try {
    r1 = this.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  return (this.mul(m) + Number(arg).mul(m)).div(m);
};
//减法
Number.prototype.sub = function(arg) {
  return this.add(-arg);
};
//除法
Number.prototype.div = function(arg) {
  var t1 = 0,
    t2 = 0,
    r1,
    r2;
  try {
    t1 = this.toString().split(".")[1].length;
  } catch (e) {}
  try {
    t2 = arg.toString().split(".")[1].length;
  } catch (e) {}
  r1 = Number(this.toString().replace(".", ""));
  r2 = Number(arg.toString().replace(".", ""));
  return (r1 / r2) * Math.pow(10, t2 - t1);
};

//四舍五入保留两位 s 数
Number.prototype.toFixed = function(s) {
  var that = this,
    changenum,
    index;
  // 负数
  if (this < 0) {
    that = -that;
  }
  changenum = (
    parseInt(that * Math.pow(10, s) + 0.5) / Math.pow(10, s)
  ).toString();
  index = changenum.indexOf(".");
  if (index < 0 && s > 0) {
    changenum = changenum + ".";
    for (var i = 0; i < s; i++) {
      changenum = changenum + "0";
    }
  } else {
    index = changenum.length - index;
    for (var i = 0; i < s - index + 1; i++) {
      changenum = changenum + "0";
    }
  }

  if (this < 0) {
    return `${-changenum}`;
  } else {
    return `${changenum}`;
  }
};

export default {
  contrastNum
};



// WEBPACK FOOTER //
// ./src/public/utils/contrastUtils.js